import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const quillDocumentApi = {
    getQuillDocumentById: (id: number): Observable<Dtos.GetQuillDocumentByIdResponse> => {
        //Create the request.
        let request: Dtos.GetQuillDocumentById = new Dtos.GetQuillDocumentById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetQuillDocumentByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getQuillDocumentByTypeAndPage: (type: Dtos.QuillDocumentType, page: Dtos.Page): Observable<Dtos.GetQuillDocumentByTypeAndPageResponse> => {
        //Create the request.
        let request: Dtos.GetQuillDocumentByTypeAndPage = new Dtos.GetQuillDocumentByTypeAndPage();

        request.type = type;
        request.page = page;

        //Send request.
        const response: Promise<Dtos.GetQuillDocumentByTypeAndPageResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getQuillDocumentsBySearch: (search: string): Observable<Dtos.GetQuillDocumentsBySearchResponse> => {
        //Create the request.
        let request: Dtos.GetQuillDocumentsBySearch = new Dtos.GetQuillDocumentsBySearch();

        request.search = search;

        //Send request.
        const response: Promise<Dtos.GetQuillDocumentsBySearchResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setQuillDocument: (quillDocument: Dtos.QuillDocument): Observable<Dtos.SetQuillDocumentResponse> => {

        let request: Dtos.SetQuillDocument = new Dtos.SetQuillDocument();

        request.quillDocument = quillDocument;

        // send request
        const response: Promise<Dtos.SetQuillDocumentResponse> = client.post(request);

        return Observable.from(response);

    },
    createQuillDocument: (type: Dtos.QuillDocumentType, page: Dtos.Page): Observable<Dtos.CreateQuillDocumentResponse> => {
        //Create the request.
        let request: Dtos.CreateQuillDocument = new Dtos.CreateQuillDocument();

        request.type = type;
        request.page = page;

        //Send request.
        const response: Promise<Dtos.CreateQuillDocumentResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateQuillDocument: (quillDocument: Dtos.QuillDocument): Observable<Dtos.ValidateQuillDocumentResponse> => {
    
        let request: Dtos.ValidateQuillDocument = new Dtos.ValidateQuillDocument();
    
        request.quillDocument = quillDocument;

        // send request
        const response: Promise<Dtos.ValidateQuillDocumentResponse> = client.post(request);

        return Observable.from(response);

    }
}